import { LanguageCodes } from '../types/preference.type';

export class CurrencyUtils {
    public static formatCurrency(amount: number, currency: string, locale: string = LanguageCodes.EN_US): string {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            currencyDisplay: 'symbol',
        }).format(amount);
    }
}
